import * as types from '../store/types';
import resources from '../helpers/resources';
import select from '../store/selectors';
import { setPaymentPayWay } from './payment';

export function addPayWay(id, payWayData) {
  return (dispatch, getState) => {
    dispatch({
      type: types.PAY_WAY_FETCHED,
      payload: {
        id,
        data: payWayData,
      },
    });

    const selector = select(getState());

    return selector.getPayWay(id);
  };
}

export function fetchPayWay(id) {
  return async (dispatch) => {
    const resp = await resources().getPayWay(id);

    return dispatch(addPayWay(id, resp.data));
  };
}

export function selectPayWay(id) {
  return {
    type: types.SELECT_PAY_WAY,
    payload: id,
  };
}

export function selectPaymentPayWay(id) {
  return (dispatch) => {
    dispatch(setPaymentPayWay(id));

    dispatch(selectPayWay(id));
  };
}
